import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    strict: process.env.NODE_ENV === 'developement',
    modules: require
        .context('./modules/', true, /^\.\/.*\.js$/)
        .keys()
        .reduce((modules, file) => {
            const module = file.replace('./', '').replace('.js', '')
            modules[module] = require(`./modules/${module}`).default
            return modules
        }, {}),
})
